import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { FiMail, FiLock, FiUser, FiEye, FiEyeOff } from 'react-icons/fi';
import './Login.css';

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let result;
      if (isLogin) {
        result = await login(formData.email, formData.password);
      } else {
        result = await register(formData.name, formData.email, formData.password, formData.role);
      }

      if (result.success) {
        toast.success(isLogin ? 'Welcome back!' : 'Account created successfully!');
        navigate('/');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handleDemoLogin = async (role) => {
    setLoading(true);
    const demoAccounts = {
      administrator: { email: 'admin@geoventory.com', password: 'password123' },
      loss_adjuster: { email: 'adjuster@geoventory.com', password: 'password123' },
      viewer: { email: 'viewer@geoventory.com', password: 'password123' }
    };

    const account = demoAccounts[role];
    const result = await login(account.email, account.password);

    if (result.success) {
      toast.success(`Logged in as ${role.replace('_', ' ')}`);
      navigate('/');
    } else {
      toast.error('Demo account not available. Please run seed script first.');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-background">
        <div className="bg-pattern"></div>
        <div className="bg-particles"></div>
        <div className="bg-grid"></div>
      </div>

      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="logo">
              <span className="logo-icon">🌍</span>
              <div className="logo-text">
                <h1>Geoventory</h1>
                <span>AI-Powered Property Evaluation</span>
              </div>
            </div>
            <p className="login-subtitle">
              Earth Observation Climate Resilience Platform 
            </p>
            
          </div>

          <div className="login-tabs">
            <button 
              className={`tab ${isLogin ? 'active' : ''}`}
              onClick={() => setIsLogin(true)}
            >
              Sign In
            </button>
            <button 
              className={`tab ${!isLogin ? 'active' : ''}`}
              onClick={() => setIsLogin(false)}
            >
              Register
            </button>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            {!isLogin && (
              <div className="form-group">
                <label>Full Name</label>
                <div className="input-wrapper">
                  <FiUser className="input-icon" />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter your full name"
                    required={!isLogin}
                  />
                </div>
              </div>
            )}

            <div className="form-group">
              <label>Email Address</label>
              <div className="input-wrapper">
                <FiMail className="input-icon" />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Password</label>
              <div className="input-wrapper">
                <FiLock className="input-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Enter your password"
                  required
                />
                <button 
                  type="button" 
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            {!isLogin && (
              <p className="register-note">
                New accounts are created with <strong>Viewer</strong> access. An administrator can upgrade your role later.
              </p>
            )}

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'Please wait...' : (isLogin ? 'Sign In' : 'Create Account')}
            </button>
          </form>

          <div className="demo-section">
            <div className="divider">
              <span>or try demo accounts</span>
            </div>
            <div className="demo-buttons">
              <button 
                className="demo-btn admin"
                onClick={() => handleDemoLogin('administrator')}
                disabled={loading}
              >
                <span className="demo-icon">👑</span>
                Administrator
              </button>
              <button 
                className="demo-btn adjuster"
                onClick={() => handleDemoLogin('loss_adjuster')}
                disabled={loading}
              >
                <span className="demo-icon">🔍</span>
                Loss Adjuster
              </button>
              <button 
                className="demo-btn viewer"
                onClick={() => handleDemoLogin('viewer')}
                disabled={loading}
              >
                <span className="demo-icon">👁️</span>
                Viewer
              </button>
            </div>
          </div>

          <div className="login-footer">
            <p className="copyright">
              © {new Date().getFullYear()} Geoventory | All rights reserved.
            </p>
            <p className="powered-by">
              
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
